import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "logo-section" }
const _hoisted_2 = { class: "agent-pill-text" }
const _hoisted_3 = { class: "agent-dropdown" }
const _hoisted_4 = { class: "agent-dropdown-label" }
const _hoisted_5 = { class: "d-flex align-center nav-right-section" }
const _hoisted_6 = { class: "user-name" }

import avatar from '@/assets/avatar.jpg';
import ottuLogo from '@/assets/ottu-logo.svg';
import { type Agent } from '@/services/agentService';
import { computed, ref, watch } from 'vue';
import SettingsDialog from '../SettingsDialog.vue';
import { useAgentStore } from '@/stores/agentStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavbar',
  props: {
    drawer: { type: Boolean },
    isMobile: { type: Boolean },
    userName: {},
    userEmail: {},
    isAuthenticated: { type: Boolean }
  },
  emits: ["logout", "go-home", "update:drawer", "select-agent"],
  setup(__props: any, { emit: __emit }) {

const agentStore = useAgentStore();

const props = __props;

const emit = __emit;

const drawer = computed({
  get: () => props.drawer,
  set: (value) => emit('update:drawer', value),
});

const agentMenuOpen = ref(false);
const pillBtnRef = ref<{ $el: HTMLElement } | null>(null);
const pillWidth = ref(0);

// Measure after DOM paint so offsetWidth is accurate
watch(
  pillBtnRef,
  (newRef) => {
    if (newRef?.$el) {
      pillWidth.value = (newRef.$el as HTMLElement).offsetWidth;
    }
  },
  { flush: 'post' },
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    flat: "",
    height: "72",
    class: "nav-bar"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              icon: "",
              size: "small",
              variant: "text",
              ripple: false,
              class: "menu-icon",
              "aria-label": "Toggle navigation menu",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = !drawer.value))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: 20,
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("mdi-menu", -1)
                  ])),
                  _: 1,
                  __: [4]
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 1,
              alt: "Ottu Logo",
              src: _unref(ottuLogo),
              class: "ottu-logo",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('go-home')))
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        (_ctx.isMobile && _unref(agentStore).selectedAgent)
          ? (_openBlock(), _createBlock(_component_v_menu, {
              key: 2,
              modelValue: agentMenuOpen.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((agentMenuOpen).value = $event)),
              location: "bottom start",
              offset: [30, 0],
              "close-on-content-click": true,
              width: pillWidth.value || undefined,
              "min-width": 0
            }, {
              activator: _withCtx(({ props: menuProps }) => [
                _createVNode(_component_v_btn, _mergeProps({
                  ref_key: "pillBtnRef",
                  ref: pillBtnRef
                }, menuProps, {
                  class: "agent-pill",
                  color: "primary",
                  variant: "flat",
                  ripple: false,
                  "aria-label": "Switch agent"
                }), {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: 18,
                      color: "white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(agentStore).selectedAgent?.icon || 'mdi-robot-outline'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(agentStore).selectedAgent?.name.split(' ')[0]), 1)
                  ]),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(agentStore).agents, (agent) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: agent.id,
                      class: _normalizeClass(["agent-dropdown-item", {
              'agent-dropdown-item--active':
                _unref(agentStore).selectedAgent?.id === agent.id,
            }])
                    }, [
                      _createVNode(_component_v_icon, {
                        size: 18,
                        color: "white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(agent.icon), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(agent.name.split(' ')[0]), 1)
                    ], 2))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "width"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(SettingsDialog),
        (!_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_v_divider, {
              key: 0,
              vertical: "",
              thickness: 2
            }))
          : _createCommentVNode("", true),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createBlock(_component_v_menu, {
              key: 1,
              location: "bottom end"
            }, {
              activator: _withCtx(({ props }) => [
                (_ctx.isMobile)
                  ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                      icon: "",
                      ripple: false,
                      class: "user-avatar-btn"
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: _unref(avatar),
                          alt: `${_ctx.userName}'s avatar`,
                          class: "user-image"
                        }, null, 8, ["src", "alt"])
                      ]),
                      _: 2
                    }, 1040))
                  : (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 1 }, props, { class: "user-btn" }), {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: _unref(avatar),
                          alt: `${_ctx.userName}'s avatar`,
                          class: "user-image"
                        }, null, 8, ["src", "alt"])
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: 24,
                          "aria-hidden": "true"
                        }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-chevron-down", -1)
                          ])),
                          _: 1,
                          __: [5]
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userName), 1)
                      ]),
                      _: 2
                    }, 1040))
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userName), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userEmail), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_list_item, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('logout')))
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("mdi-logout", -1)
                          ])),
                          _: 1,
                          __: [6]
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode("Logout", -1)
                          ])),
                          _: 1,
                          __: [7]
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})